import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import {
  AUTH_HEADER,
  SECURE_BASE_URL_KEY,
  SECURE_AUTH_TOKEN_KEY,
} from "../../../base";
import { FetchState } from "../../../domain/models/fetch-state";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { addTourDeviation } from "../../../domain/useages/tour-deviation-report/add-tour-deviation";
import { RemoteAddTourDeviation } from "../../../data/usecases/tour-deviation-report/remote-add-tour-deviation";
import Endpoints from "../../../domain/endpoints";

export interface addTourDeviationInterface {
  addTourDeviation: Function;
  addTourDeviationState: FetchState;
}

const initialState = {
  addTourDeviationState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useAddTourDeviationSlice: StateCreator<
  addTourDeviationInterface
> = (set, get) => ({
  ...initialState,
  addTourDeviation: async (payload: addTourDeviation.Params) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteAddTourDeviation = new RemoteAddTourDeviation(
      `${BASE_URL}${Endpoints.ADD_TOUR_DEVIATION}`,
      axiosHttpClient
    );
    set({ addTourDeviationState: FetchState.LOADING });

    let result = await remoteAddTourDeviation.add(payload);
    return result;
  },
});
